import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { FieldsetAPI} from '@philips-internal/oswald-ui-components';
import { AttributesProps, DeviceAttributes} from '../commons/register-device';
import { Endpoint } from '../../../constants/endpoints';
import { DataContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { AbortableSubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { DeviceUtils } from '../../../utils/device-utils';

export class DevicesDynamicForm {

  private static _ruleSequence: number;

  public static get ruleSequence(): number {
    return this._ruleSequence;
  }

  public static set ruleSequence(value: number) {
    this._ruleSequence = value;
  }

  public static readonly handleDynamicFields = (fieldsetDynamicAPI: FieldsetAPI, deviceSequence: unknown, deviceType: string, context: DataContext): void => {
    fieldsetDynamicAPI.setVisible(false);

    HttpService.get(Endpoint.GET_DYNAMIC_FIELDS_DEVICES_VIEWER, {
      deviceSequence,
      deviceType
    }).then(response => {
      const responseBody = response.body as AttributesProps;
      const dynamicFields = responseBody.component;
      if (responseBody.ruleSequence) {
        this.ruleSequence = responseBody.ruleSequence;
      }
      if (responseBody.values) {
        fieldsetDynamicAPI.setVisible(true);
        context.set({ dynamicFields});
      }
    });
  }

  public static readonly createFormPattern = (event: AbortableSubmitEvent): DeviceAttributes[] => {
    const keys = Object.keys(event.record);
    const values = Object.values(event.record);
    return keys.map((key, index) => {
      if (!Number.isNaN(Number(key))) {
        const deviceAttributes = {
          ruleSequence: this.ruleSequence,
          seqItem: Number([key][0]),
          value: (values[index]).value ? String((values[index]).value) : String(values[index])
        };
        return deviceAttributes
      }
      return {
        ruleSequence: this.ruleSequence,
        seqItem: [key][0],
        value: values[index].value
      }
    }).filter(DeviceUtils.isNumberType)
  }
}
